import BarekamButton, { ActionbarButtons, SimpleButtons } from "../../../components/button";
import React from "react";
import { UserActionbarButtonsContainer, UserActionbarContainer } from "./styled";
import { useAppSelector } from "../../../../redux/store";

export const ActionBarWithSaveButton = ({ disabled, secondaryActionText, primaryActionText, headerText, onSecondaryActionClick, onPrimaryActionClick }: UserActionbarProps) => {
    const { matchesPhone } = useAppSelector(state => state.deviceReducer);

    if (matchesPhone) {
        return (
            <UserActionbarContainer style={{ width: '100%' }}>
                <UserActionbarButtonsContainer style={{ flexDirection: 'column', width: '100%' }}>
                    {headerText || <div />}

                    {primaryActionText
                        ? <BarekamButton disabled={disabled}
                            type={ActionbarButtons.NEW}
                            size={"m"}
                            sx={{ width: '100%' }}
                            onClick={() => onPrimaryActionClick && onPrimaryActionClick()}>
                            {primaryActionText}
                        </BarekamButton>
                        : <></>
                    }
                    {secondaryActionText
                        ? <BarekamButton disabled={disabled} type={SimpleButtons.LINK} onClick={() => onSecondaryActionClick && onSecondaryActionClick()}>
                            {secondaryActionText}
                        </BarekamButton>
                        : <></>
                    }
                </UserActionbarButtonsContainer>
            </UserActionbarContainer>
        )
    } else {
        return (
            <UserActionbarContainer>
                {headerText || <div />}

                <UserActionbarButtonsContainer style={{ flexDirection: 'row' }}>
                    {secondaryActionText
                        ? <BarekamButton disabled={disabled} type={SimpleButtons.LINK} onClick={() => onSecondaryActionClick && onSecondaryActionClick()}>
                            {secondaryActionText}
                        </BarekamButton>
                        : <></>
                    }
                    {primaryActionText
                        ? <BarekamButton disabled={disabled} type={ActionbarButtons.NEW} size={"s"}
                            onClick={() => onPrimaryActionClick && onPrimaryActionClick()}>
                            {primaryActionText}
                        </BarekamButton>
                        : <></>
                    }
                </UserActionbarButtonsContainer>
            </UserActionbarContainer>
        )
    }
}

interface UserActionbarProps {
    onSecondaryActionClick?: () => void,
    onPrimaryActionClick?: () => void,
    primaryActionText?: JSX.Element,
    secondaryActionText?: JSX.Element,
    headerText?: JSX.Element,
    disabled?: boolean,
}